import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getTerms } from "../../redux/actions/termActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (termId: string) => void;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const TermSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Term",
  allLabel = "All Terms",
  minWidth = 130,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: terms,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.term);
  const attempted = useRef(false);

  useEffect(() => {
    if (!terms.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getTerms());
    }
  }, [dispatch, terms.length, loading, error]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={terms.map((t) => ({ value: t.id, label: t.name }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};
export default TermSelectFilter;
